
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useMailerLiteSync = () => {
  const [isAddingToMailerLite, setIsAddingToMailerLite] = useState(false);

  const addEmailToMailerLite = async (email: string) => {
    if (!email) return;
    
    try {
      setIsAddingToMailerLite(true);
      
      console.log("Adding email to MailerLite group:", email);
      
      const { data, error } = await supabase.functions.invoke('mailerlite-sync', {
        body: { email }
      });
      
      if (error) {
        console.error("Error adding email to MailerLite:", error);
      } else {
        console.log("Successfully added email to MailerLite:", data);
      }
    } catch (error) {
      console.error("Exception adding email to MailerLite:", error);
    } finally {
      setIsAddingToMailerLite(false);
    }
  };

  return { addEmailToMailerLite, isAddingToMailerLite };
};
